import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { HTML_LINK_TARGET } from '../../../constants/html'
import { ROUTE_PATH_LIST_AUTH } from '../../../constants/route'
import { getQaSelector } from '../../../utils/common'
import { Link, LINK_UNDERLINE } from '../../Link'

import {
  QA_NAME_AUTH_FOOTER_ABOUT_LINK,
  QA_NAME_AUTH_FOOTER_HELP_CENTER_LINK,
} from './AuthFooter.constants'

import * as styles from './AuthFooter.module.css'

function AuthFooter({ className = styles.AuthFooter, withNotifications }) {
  const { t } = useTranslation()

  const aboutLinkQaProps = getQaSelector({
    value: QA_NAME_AUTH_FOOTER_ABOUT_LINK,
  })

  const helpCenterLinkQaProps = getQaSelector({
    value: QA_NAME_AUTH_FOOTER_HELP_CENTER_LINK,
  })

  return (
    <div
      className={classNames(className, {
        [styles.withNotifications]: withNotifications,
      })}
    >
      <div className={styles.about}>
        <span>© {t('Auth.PoweredByKey')}</span>
        <Link
          {...aboutLinkQaProps}
          className={styles.aboutLink}
          to={ROUTE_PATH_LIST_AUTH.about}
          variant={LINK_UNDERLINE}
        >
          {t('Auth.AboutLinkKey')}
        </Link>
        <Link
          {...helpCenterLinkQaProps}
          className={styles.link}
          rel='noopener noreferrer'
          target={HTML_LINK_TARGET.blank}
          to='https://idwell.crunch.help'
          variant={LINK_UNDERLINE}
        >
          {t('Auth.HelpCenterLinkKey')}
        </Link>
      </div>
    </div>
  )
}

export default AuthFooter
